/**
 * 
 */
export enum ToastType {

    /**
     * @description success
     */
    Success = 'success',

    /**
     * @description error
     */
    Error = 'error',

    /**
     * @description info
     */
    Info = 'info',

    /**
     * @description warning
     */
    Warning = 'warning',

    /**
     * @description default
     */
    Default = 'default'
}

/**
 * @description
 * Union type for toast type variants that accepts both enum values and string literals
 * @example
 * ```typescript
 * // Can use enum values
 * @Input() type: IToastType = ToastType.Success;
 * 
 * // Can use string literals
 * @Input() type: IToastType = 'success';
 * ```
 */
export type IToastType = ToastType | 'success' | 'error' | 'info' | 'warning' | 'default';